module.exports = __webpack_public_path__ + "img/app-icon.e43ac072.png";